import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classNames from 'classnames';
import Button from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import NoFilter from '@helsenorge/designsystem-react/components/Icons/NoFilter';
import { KeyboardEventKey, useFocusToggle, useFocusTrap, useKeyboardEvent } from '@helsenorge/designsystem-react';
import styles from './styles.module.scss';
const NoScroll = () => (_jsx("style", { children: `body {
  overflow: hidden;
  width: 100vw;
  min-width: 100%;
}` }));
const OffCanvas = props => {
    const { isOpened } = props;
    const [isVisible, setIsVisible] = React.useState(isOpened);
    const wrapperRef = React.useRef(null);
    React.useEffect(() => {
        if (isOpened) {
            setIsVisible(true);
        }
    }, [isOpened]);
    const handleTransitionEnd = () => {
        if (!isOpened) {
            setIsVisible(false);
        }
    };
    useFocusTrap(wrapperRef, isOpened);
    useFocusToggle(wrapperRef, isOpened);
    const handleKeyboardEvent = (e) => {
        e.stopPropagation();
        e.preventDefault();
        props.onClose();
    };
    useKeyboardEvent(wrapperRef, handleKeyboardEvent, [KeyboardEventKey.Escape]);
    const wrapperClasses = classNames(styles.offcanvas, { [styles['offcanvas--open']]: isOpened, [styles['offcanvas--not-visible']]: !isVisible }, props.className);
    const contentClasses = classNames(styles.offcanvas__content, { [styles['offcanvas__content--is-loading']]: props.isLoading });
    return (_jsxs("div", { ref: wrapperRef, className: wrapperClasses, onTransitionEnd: handleTransitionEnd, children: [isOpened && _jsx(NoScroll, {}), _jsx("div", { className: styles.offcanvas__header, children: props.header }), _jsxs("div", { className: contentClasses, children: [props.children, props.resetActiveFilters && (_jsxs(Button, { onClick: props.resetActiveFilters, variant: 'borderless', children: [_jsx(Icon, { svgIcon: NoFilter }), 'Nullstill filter'] }))] }), props.afterContent] }));
};
export default OffCanvas;
